import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import { addTrigger } from '@bingads-webui-campaign/user-voice';

export class GiveFeedback extends React.PureComponent {
  componentDidMount() {
    addTrigger({
      triggerId: this.aEl,
      featureName: this.props.featureName,
      areaName: this.props.areaName,
    });
  }

  render() {
    return (
      <button
        id="feedback-label"
        className="btn-link"
        ref={(el) => {
          this.aEl = el;
        }}
      >
        <span className={classnames('glyphicon', 'glyphicon-bullhorn')} aria-hidden="true" />
        {this.props.children}
      </button>
    );
  }
}

GiveFeedback.propTypes = {
  areaName: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  featureName: PropTypes.string.isRequired,
};

